import validate from "/usr/src/app/content/n3-treatments-23cc1c92-282d-43ca-b967-9629a8a585d7/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-23cc1c92-282d-43ca-b967-9629a8a585d7/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}